<template>
  <div>
    <Collapse v-model="value" simple style="border:0">
      <Panel name="1" hide-arrow style="margin: 20px 0;border:0">
        <FormTitle :titleText="$t('Welfare_Information')" /><!-- 福利信息 -->
        <div slot="content" style="margin-top: 40px;">
          <Form :label-width="160" label-position="left">
            <Row :gutter="100">
              <Col :xs="24" :sm="24" :md="12" :lg="12">
                <FormItem :label="$t('Bank_Account')"
                  ><!-- 银行卡号 -->
                  <Input v-model="formItem.bankid1" :disabled="id !== ''" />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="12">
                <FormItem :label="$t('Bank_Name_')"
                  ><!-- 银行名称 -->
                  <!-- <DatePicker type="date" v-model="formItem.meetingDate" style="width:100%"></DatePicker> -->
                  <Input v-model="formItem.bankname1" :disabled="id !== ''" />
                </FormItem>
              </Col>
              <Col :xs="24" :sm="24" :md="12" :lg="12">
                <FormItem :label="$t('CNAPS')"
                  ><!-- 银行行号 -->
                  <Input v-model="formItem.bankname2" :disabled="id !== ''" />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>

    <Divider />
    <Spin size="large" fix v-if="spinShow"></Spin>
    <div class="btnfooter">
      <Button type="primary" class="btn" @click="save"
        ><!-- 保存 -->{{ $t("Save") }}</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      spinShow: false,
      formItem: {},
      list: [],
      value: [1],
      id: "",
      serialnumber: ""
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  methods: {
    getData(val) {
      this.spinShow = true;
      val
        ? (this.serialnumber = val)
        : (this.serialnumber = JSON.parse(
            sessionStorage.getItem("userInfo")
          ).serialnumber);
      axios
        .post("/employeeInformation/getEmployeeInformation", {
          serialnumber: this.serialnumber
        })
        .then(res => {
          this.spinShow = false;
          if (res) {
            this.formItem = res;
          }
        });
    },
    save() {
      this.$Modal.confirm({
        title: this.$t("修改操作具有法律效力"),
        onOk: () => {
          axios
            .post("/employeeInformation/updateEmployeeInformation", {
              serialnumber: this.serialnumber,
              ...this.formItem
            })
            .then(res => {
              if (res) {
                this.$Message.success(this.$t("Save_Successful"));
                this.getData(this.serialnumber);
              }
            });
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.btnfooter {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>



// WEBPACK FOOTER //
// src/components/process/files/components/BenefitInformation.vue